import { InjectionToken } from '@angular/core';
import { AppConfig } from '../../types/app-config.model';

export const APP_CONFIG = new InjectionToken<AppConfig>(
  'Application Configuration',
);

export const APP_CONFIG_FEATURE_KEY = 'app-config';
